import { manifesto, profile } from "@/data/portfolio";
import { Reveal } from "@/lib/motion";
import { TID } from "@/constants/testIds";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

function SectionHeader({ label, title }) {
  return (
    <Reveal className="mb-14 max-w-3xl">
      <div className="mb-4 flex items-center gap-3">
        <span className="kicker">{label}</span>
        <span className="h-px flex-1 bg-border" />
      </div>
      <h2 className="font-display text-[clamp(2rem,4.5vw,3.25rem)] font-bold leading-[1.02] text-foreground">
        {title}
      </h2>
    </Reveal>
  );
}

export function About() {
  return (
    <section id="about" data-testid={TID.about} className="mx-auto max-w-6xl px-5 py-20 sm:px-8 sm:py-24">
      <SectionHeader label="01 / about" title="An engineer for the failure paths." />

      <Reveal className="mb-16 max-w-3xl text-lg leading-relaxed text-muted-foreground sm:text-xl">
        {manifesto.intro}
      </Reveal>

      <div className="md:hidden">
        <Accordion type="single" collapsible className="overflow-hidden rounded-2xl border border-border bg-border">
          {manifesto.chapters.map((c) => (
            <AccordionItem key={c.n} value={c.n} className="border-border bg-card/60 px-5">
              <AccordionTrigger className="py-5 font-display text-left text-xl font-bold text-foreground no-underline hover:no-underline">
                <span className="flex items-center gap-3">
                  <span className="font-mono text-2xl font-semibold text-primary/80">{c.n}</span>
                  {c.title}
                </span>
              </AccordionTrigger>
              <AccordionContent className="pb-6">
                <p className="text-[0.98rem] leading-[1.8] text-muted-foreground">{c.body}</p>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>

      <div className="hidden grid-cols-1 gap-px overflow-hidden rounded-2xl border border-border bg-border md:grid md:grid-cols-3">
        {manifesto.chapters.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.08} className="flex flex-col gap-5 bg-card/60 p-7">
            <span className="font-mono text-3xl font-semibold text-primary/80">{c.n}</span>
            <h3 className="font-display text-xl font-bold text-foreground">{c.title}</h3>
            <p className="text-[0.98rem] leading-[1.8] text-muted-foreground">{c.body}</p>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1} className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-3 font-mono text-sm text-muted-foreground">
        <span>Based in {profile.location}</span>
        <span className="hidden h-3 w-px bg-border sm:block" />
        <span>{profile.education}</span>
        <span className="hidden h-3 w-px bg-border sm:block" />
        <span>{profile.status}</span>
      </Reveal>
    </section>
  );
}

export { SectionHeader };
